import { withI18n } from 'panda-i18n';
import locale from '@/locale';
import { attachPropertiesToComponent } from '@/components/cn-picker/attach-properties-to-component';
import { CnMonthPickerPro } from './month-picker';
import { CnYearPickerPro } from './year-picker';
import { CnWeekPickerPro } from './week-picker';
import { CnRangeDatePickerPro } from './range-date-picker';
import { prompt } from './prompt';
import UICnDatePicker from './date-picker';
UICnDatePicker.displayName = 'CnDatePickerPro';
const CnDatePicker = withI18n(UICnDatePicker, {
    locale,
    _noHoc: true,
});
const CnDatePickerPro = attachPropertiesToComponent(CnDatePicker, {
    prompt,
});
CnDatePickerPro.displayName = 'CnDatePickerPro';
export { CnDatePickerPro, CnDatePickerPro as CnDatePicker, CnMonthPickerPro, CnYearPickerPro, CnWeekPickerPro, CnRangeDatePickerPro, CnRangeDatePickerPro as CnDateRangePickerPro, };
